import React, { useState } from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";

interface UserCardProps {
    id: string;
    name: string;
    mobile: string;
    showCheckbox?: boolean;
    bottomText: string;
    onBottomClick?: (id: string) => void;
}

const UserCard: React.FC<UserCardProps> = ({ name, mobile, id, showCheckbox, bottomText, onBottomClick, }) => {
    const [checked, setChecked] = useState(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
    };

    const handleBottomClick = () => {
        if (onBottomClick) {
            onBottomClick(id); 
        }
    };

    return (
        <Box
            sx={{
                border: "0.8px solid rgb(223, 218, 218)",
                borderRadius: 2,
                bgcolor: "#fff",
                width: "100%",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
            }}
        >
            {/* Top Section */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: 1,
                    flexWrap: "wrap",
                    rowGap: 0.5
                }}
            >
                {/* Left section - centered vertically */}
                <Box sx={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0 }}>
                    {showCheckbox && (
                        <Checkbox
                            checked={checked}
                            onChange={handleChange}
                            size="small"
                            sx={{
                                color: "#28bea9",
                                p: 0,
                                transform: "scale(0.8)",
                                "&.Mui-checked": {
                                    color: "#5fc3b1",
                                },
                                mr: 0.4,
                            }}
                        />
                    )}

                    {/* Name & ID vertically stacked */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3, minWidth: 0, flex: 1 }}>
                        <Typography sx={{ fontWeight: 500, fontSize: 13, wordBreak: "break-word", whiteSpace: "normal" }}>
                            {name}
                        </Typography>
                        <Typography sx={{ color: "#929293", fontSize: 11, wordBreak: "break-word", whiteSpace: "normal" }}>
                            {id}
                        </Typography>
                    </Box>
                </Box>

                {/* Right section - aligned to top */}
                {mobile && mobile !== "" && <Box sx={{ display: "flex", alignItems: "flex-start", mt: 0.2, minWidth: 0, wordBreak: "break-word", maxWidth: "100%" }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <PhoneIcon sx={{ fontSize: 10, mr: 0.5 }} />
                        <Typography sx={{ color: "#9a9999", fontSize: 10, wordBreak: "break-word", whiteSpace: "normal" }}>
                            {mobile}
                        </Typography>
                    </Box>
                </Box>}
            </Box>

            {/* Bottom Section */}
            <Box
                sx={{
                    bgcolor: "#fafafb",
                    p: 1,
                    display: "flex",
                    justifyContent: "flex-end",
                    borderRadius: "0 0 8px 8px",
                    cursor: "pointer",
                }}
                onClick={handleBottomClick}
            >
                <Typography sx={{ fontWeight: 700, color: "#787878", fontSize: 10 }}>
                    {bottomText} &gt;
                </Typography>
            </Box>
        </Box>
    );
};

export default UserCard;
